module.exports = __webpack_public_path__ + "img/delete.e2e03c53.png";